import { getPremiumContext } from "@memorang/helpers/bundle";
import { isWeb } from "@memorang/helpers/platform";
import type {
	BundleSubscription,
	ExamDetails,
	ProductType,
} from "@memorang/types";
import { getShowStudyPackViews } from "./exams";

export type Entitlement = {
	kind: "prep" | "product";
	id: string;
	name: string;
	icon: string;
	examName: string;
	productType: ProductType;
	subscription: BundleSubscription;
};

export const getEntitlements = (examsList: ExamDetails[]): Entitlement[] => {
	return (examsList ?? []).flatMap<Entitlement>(({ exam }) =>
		exam.bundles
			.filter((item) => {
				if (!getPremiumContext(item.metadata).hasAccess) {
					return false;
				}
				if (item.bundle.bundleType === "PREP") {
					return true;
				}
				return item.bundle.bundleType === "PRACTICE_TEST"
					? isWeb
					: getShowStudyPackViews(exam.studyPackCollection?.[0]);
			})
			.map(({ bundle, metadata }) => ({
				kind: bundle.bundleType === "PREP" ? "prep" : "product",
				id: bundle.id,
				name: bundle.name,
				icon: bundle.icon.url,
				examName: bundle.examName,
				productType: bundle.bundleType,
				subscription: metadata.subscription,
			})),
	);
};
